module.exports = __webpack_public_path__ + "img/2_221.040ec42b.png";